import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';

//import { UserService } from '../../../services/user.service';
import { CommonDataService } from '../../../services/common-data.service';

declare var $:any;
declare var iziToast:any;

declare var $:any;

@Component({
  selector: 'app-product-gallery',
  templateUrl: './product-gallery.component.html',
  styleUrls: ['./product-gallery.component.css']
})
export class ProductGalleryComponent implements OnInit {

  pageName = "Gallery - Product Images";
  modelData: any;
  modelName = 'Order';
  modelId = '0';

  constructor(private router: Router, private formBuilder: FormBuilder, private _data: CommonDataService)  {

    let modelObject1 = new FormData();

    modelObject1.append('modelName', this.modelName);

    $('#loader').show();
    //lets get the model for this page
        this._data.getModelData(modelObject1) 
        .pipe(first())
        .subscribe(
          data => {
            console.log(data);
            this.modelData = data['queryData'];

          },
          error => {

            console.log(error);
            iziToast.success({
              title: 'Error!',
              position: 'topRight',
              icon: 'icon-circle-check',
              message: 'Failed to retrieve profile info.'
          });

          $('#loader').hide();

          },

          () => {
              $('#loader').hide();
          }
      );
   }

  ngOnInit() {
    $('#initialise-page').trigger('click');
    $('#owl-initialise').trigger('click');
  }

}
